module.exports = "/_next/static/images/CustomerStoryFender-a1786ac436645ab0d4f61480a9e420e2.png";